<template>
  <div class="m-t m-b" :class="active ? 'active' : 'inactive'">
    <div class="line-height-15">{{ status }}</div>
    <div class="line-height-15 font-sm">{{ phase }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phase: null,
      active: null,
    };
  },
  beforeMount() {
    this.active = this.params.data.phase?.toLowerCase().startsWith("active");
    this.status = this.params.data.phase?.split(" ")[0];
    this.phase = this.params.data.phase?.split(" ").slice(1).join(" ");
  },
};
</script>

<style scoped>
.active {
  color: var(--font-color-green);
}
.inactive {
  color: var(--red-light);
}
</style>
